import styled from 'styled-components';
import defaultTheme from '../../config/theme';

const HeaderTitle = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.headerFontSize};
  color: ${({theme}) => theme.headerFontColor};
`;

HeaderTitle.defaultProps = {
  theme: defaultTheme
};

export default HeaderTitle;